import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DisplayBoardRegistrationRoutingModule } from './display-board-registration-routing.module';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DisplayBoardRegistrationRoutingModule,
    SharedModule
  ]
})
export class DisplayBoardRegistrationModule { }
